import {
    AccordionButton,
    AccordionIcon,
    AccordionItem,
    AccordionPanel,
    Box,
    Button,
    HStack,
    Text
} from '@chakra-ui/react';
// import Select from '@/components/Select/Select';
import { IBusinessHour, IDayID } from '@/types/BusinessHours';
import { useTranslation } from 'react-i18next';
import Interval from './components/Interval/Interval';

interface DaySelectorProps {
	id: IDayID;
	intervals?: IBusinessHour[];
	onAddClick: (id: IDayID) => void;
	onDeleteClick: (id: IDayID, index: number) => void;
	onStartChange: (id: IDayID, index: number, value: string) => void;
	onEndChange: (id: IDayID, index: number, value: string) => void;
	onCopyToAllClick: (intervals: IBusinessHour[]) => void;
	isLoading?: boolean;
}

export default function DaySelector(props: DaySelectorProps) {
	const { t } = useTranslation(); // TODO: Do not reload translation every time

	return (
		<AccordionItem>
			<h2>
				<AccordionButton>
					<Box flex="1" textAlign="left">
						{t(props.id)}
					</Box>
					<AccordionIcon />
				</AccordionButton>
			</h2>
			<AccordionPanel px={0} py={1}>
				{props.intervals?.length === 0 ? (
					<Text fontSize="xs" textAlign="center">
						{t('No intervals defined for this day')}
					</Text>
				) : null}
				{props.intervals?.map((interval, index) => (
					<Interval isLoading={props.isLoading} key={index} index={index} {...props} {...interval} />
				))}

				<HStack justifyContent="space-between" mx="2" my="4">
					<Button
						isLoading={props.isLoading}
						size="xs"
						colorScheme="blue"
						type="button"
						variant="ghost"
						onClick={() => props.onAddClick(props.id)}
					>
						{t('Add new interval')}
					</Button>

					<Button
						isLoading={props.isLoading}
						size="xs"
						colorScheme="blue"
						type="button"
						variant="ghost"
						onClick={() => props.onCopyToAllClick(props.intervals || [])}
					>
						{t('Repeat every weekday')}
					</Button>
				</HStack>
			</AccordionPanel>
		</AccordionItem>
	);
}
